/** @typedef {{ id: number, submittedAt: string, name: string, email: string, orderNumber: string, blend: string, story: string, permissionMarketing: boolean, acknowledgeEditing: boolean }} StorySubmission */

export const STORY_SUBMISSIONS_STORAGE_KEY = "mossmatrix_story_submissions_v1";

/** @returns {StorySubmission[]} */
export function loadStorySubmissions() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORY_SUBMISSIONS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** @param {Omit<StorySubmission, "id" | "submittedAt">} entry */
export function appendStorySubmission(entry) {
  const list = loadStorySubmissions();
  const row = {
    ...entry,
    id: Date.now(),
    submittedAt: new Date().toISOString(),
  };
  list.push(row);
  window.localStorage.setItem(STORY_SUBMISSIONS_STORAGE_KEY, JSON.stringify(list));
  return row;
}
